import React from 'react';
import './TeamProfiles.css';
import imgNathalie from '../../images/team/Nathalie.png';
import imgJose from '../../images/team/José.png';
import imgMiguel from '../../images/team/Migue.png';
import imgJuliana from '../../images/team/Juliana.png';

const members = [
    {
        id: 1,
        img: imgNathalie,
        name: 'Nathalie Torres Vargas',
        role: 'Psicóloga · Especialista en Desarrollo Social · Coordinación de Proyectos Sociales · Atención Psicosocial · Voluntariado · Inclusión Socioeconómica',
        bio: 'Psicóloga enfocada en desarrollo social y empoderamiento comunitario. Trabaja en proyectos de inclusión, género y bienestar psicológico, combinando consultoría, coordinación y formación. Le apasiona generar impacto positivo y fortalecer comunidades desde la empatía y la diversidad.',
    },
    {
        id: 2,
        img: imgJose,
        name: 'José Guzmán López',
        role: 'IsraAID Colombia · MBA en Alta Dirección · Comunicaciones · Relaciones Públicas',
        bio: 'Apasionado por crear ideas con impacto social, ambiental y empresarial. Persona proactiva, comprometida y orientada a la acción, que lidera con empatía y construye relaciones basadas en el respeto y el crecimiento.',
    },
    {
        id: 3,
        img: imgMiguel,
        name: 'Miguel Ariza Goenaga',
        role: 'Abogado y Politólogo · Máster en Derechos Fundamentales y Filosofía',
        bio: 'Abogado y politólogo con formación de maestría en Derechos Fundamentales y Filosofía, y más de siete años liderando proyectos sociales y de investigación. Perfil estratégico, con pensamiento crítico y habilidades para coordinar equipos y generar soluciones innovadoras.',
    },
    {
        id: 4,
        img: imgJuliana,
        name: 'Juliana Tapia Mendoza',
        role: 'Gestión de Proyectos · Desarrollo Social · Educación · Salud Comunitaria',
        bio: 'Profesional con experiencia en gestión de proyectos sociales y educativos. Con dominio de SPSS y ATLAS.ti, orientada al análisis de datos, cumplimiento de indicadores y evaluación de impacto.',
    },
];

const TeamProfiles = () => {
    return (
        <section className="wpo-team-profiles section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-7 col-xl-6">
                        <div className="wpo-section-title">
                            <span>Nuestro equipo</span>
                            <h2>Las personas detrás de la misión</h2>
                            <p>Conoce a los profesionales comprometidos que impulsan cada proyecto con vocación, experiencia y dedicación.</p>
                        </div>
                    </div>
                </div>
                <div className="row tp-cards-row">
                    {members.map((member) => (
                        <div className="col-lg-3 col-md-6 col-12" key={member.id}>
                            <div className="tp-card">
                                <div className="tp-card-photo">
                                    <img src={member.img} alt={member.name} />
                                </div>
                                <h3 className="tp-card-name">{member.name}</h3>
                                <p className="tp-card-role">{member.role}</p>
                                <p className="tp-card-bio">{member.bio}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TeamProfiles;
